import React, { Component } from 'react';
// import { v4 } from 'node-uuid';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { fetchNotebook, updateNotebook, patchNotebook } from '../../actions';

class ReadingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  // eslint-disable-next-line react/no-deprecated
  componentDidMount() {
    this.props.fetchNotebook();
  }

  handleRemoveFromQueue = (pageID) => {
    this.props.patchNotebook({ pageID }, this.props.history);
  }

  // render button to remove a story from reading list
  renderButton = (pageID) => {
    const { notebook } = this.props;
    if (notebook?.Queue?.filter((page) => page === pageID)) {
      return (
        <button key={pageID} type="submit" className="removeFromQueue" onClick={() => this.handleRemoveFromQueue(pageID)}>
          Remove from Reading List
        </button>
      );
    } else {
      return <div />;
    }
  }

  render() {
    return (
      <div className="reading-list">
        {this.props.notebook?.Queue?.map((page) => {
          return (
            <div key={page.id} className="saved-story">
              <NavLink className="queued-story-link" to={`/books/${page.Chapter?.Book}/chapters/${page.Chapter?.id}/pages/${page.id}`}>
                <p>{page.title}</p>
              </NavLink>
              {this.renderButton(page.id)}
            </div>
          );
        })}
      </div>
    );
  }
}

// connects particular parts of redux state to this components props
const mapStateToProps = (state) => (
  {
    notebook: state.notebook.current,
  }
);

// react-redux glue -- outputs Container that know state in props
// also with an optional HOC withRouter
export default withRouter(connect(mapStateToProps, { fetchNotebook, updateNotebook, patchNotebook })(ReadingList));
